import { BaseType } from '../base/base-type';
import { PaymentMethodTypeIdEnum } from '../enum/shared/payment-method-type-id.enum';

export class PaymentMethodType extends BaseType {
  public declare id: PaymentMethodTypeIdEnum;
}
